import '../common';
import React from 'react';
import ReactDom from 'react-dom';
import GoalPanel from './components/GoalPanel';
import Messages from '../common/i18n/Messages';
import MessageDefinitions from './i18n/MessageDefinitions';
import {getLocale} from '../common/i18n/Locale';
import {IntlProvider} from 'react-intl';

function render(nodeId, {goalTypesKey, goalTypes, qualifier, toggle, initialGoals = [], messages: customMessages = {}} = {}) {
  const mountNode = document.getElementById(nodeId);
  const messages = Messages.get(MessageDefinitions, customMessages);

  const goals = initialGoals.length ? initialGoals : [{}];

  window.ignite.getAnswerService().then(answerService => {
    ReactDom.render(
      <IntlProvider locale={getLocale()} messages={messages}>
        <GoalPanel
          goalTypesKey={goalTypesKey}
          goalTypes={goalTypes}
          qualifier={qualifier}
          toggle={toggle}
          initialGoals={goals}
          answerService={answerService}
        />
      </IntlProvider>,
      mountNode);
  });
}

function renderGoalPanel(goalPanelId, params) {
  render(goalPanelId, params);
}

function unmountGoalPanel(goalPanelId) {
  ReactDom.unmountComponentAtNode(document.getElementById(goalPanelId));
}

if (window.ignite) {
  window.ignite.renderGoalPanel = renderGoalPanel;

  window.ignite.unmountGoalPanel = unmountGoalPanel;
}

export {
  renderGoalPanel,
  unmountGoalPanel
};



/** WEBPACK FOOTER **
 ** ./src/main/js/goalBuilder/index.js
 **/